import { View, Image, StyleSheet } from 'react-native';
import { useTheme } from '../styles/theme';

export default function Basmala() {
  const { isDark } = useTheme();
  return (
    <View style={styles.container}>
      <View style={isDark ? styles.imageWrapperDark : styles.imageWrapper}>
        <Image
          source={{ uri: '/img/basmala.svg' }}
          style={styles.image}
          resizeMode="contain"
          accessibilityLabel="Bismillah"
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingVertical: 20,
  },
  imageWrapper: {},
  imageWrapperDark: {
    filter: 'invert(1)',
  } as any,
  image: {
    width: 260,
    height: 50,
  },
});
